module.exports = {
  siteMetadata: {
    title: `RGB Logic an Interactive Tutorial (from James Porter)`,
  },
  plugins: [`gatsby-plugin-react-helmet`, `gatsby-plugin-stylus`],
}



// WEBPACK FOOTER //
// ./gatsby-config.js